import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, CalendarIcon, Wine, Users, IceCream } from 'lucide-react';
export function CellarDoorPage() {
  return <div className="min-h-screen bg-white" data-id="element-736">
      {/* Header */}
      <Header variant="light" data-id="element-737" />

      {/* Hero Section */}
      <section className="relative min-h-[80vh] overflow-hidden pt-32" data-id="element-738">
        {/* Background Image */}
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/Peterson-House-Cellar-Door-Hero.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }} data-id="element-739" />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-740" />

        {/* Content */}
        <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-741">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-742" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-743">
            Experience
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-744">
            Cellar Door
          </h1>
          <p className="text-xl text-white mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-745">
            Over 30 sparkling wine varieties in the heart of the Hunter Valley
            wineries.
            <br data-id="element-746" />
            Life's FLAT without Bubbles!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-747">
            <a href="#cellar-door-booking" onClick={e => {
            e.preventDefault();
            document.getElementById('cellar-door-booking')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-748">
              <CalendarIcon size={18} data-id="element-749" />
              Book a Tasting
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-750" />
            </a>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="bg-white py-20 px-8" data-id="element-751">
        <div className="max-w-7xl mx-auto" data-id="element-752">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-753">
            {/* Content */}
            <div className="space-y-6 order-1" data-id="element-754">
              <div className="space-y-3" data-id="element-755">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-756"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-757">
                  Welcome
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-758">
                  An Experience Like No Other
                </h2>
              </div>
              <div className="space-y-4" data-id="element-759">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-760">
                  Peterson House Cellar Door is an experience like no other in
                  the Hunter Valley. With over 30 different sparkling wine
                  varieties, we have bubbles for everyone and every occasion.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-761">
                  One of the best wineries in the Hunter Valley, we have our
                  famous Pink Blush Rosé for the easy drinking sparkling wine,
                  to the more traditional flagship Pinot Noir Chardonnay
                  Meunier.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-762">
                  Our Cellar Door also boasts a large range of merchandise and
                  gifts, perfect for Birthdays, Mother's Day Gifts, Christmas
                  Gifts, Teacher Gifts, Anniversaries, and Valentine's Day.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2" data-id="element-763">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/landscape-cd-entry-with-wine-wall.jpg" alt="Peterson House Cellar Door" className="w-full h-full object-cover" data-id="element-764" />
            </div>
          </div>
        </div>
      </section>

      {/* Wine Tasting Section */}
      <section className="bg-neutral-100 py-20 px-8" data-id="element-765">
        <div className="max-w-7xl mx-auto" data-id="element-766">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-767">
            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-1" data-id="element-768">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterdsound-House-cellar-Door-Tasting.jpg" alt="Wine tasting at Peterson House" className="w-full h-full object-cover" data-id="element-769" />
            </div>

            {/* Content */}
            <div className="space-y-6 order-1 lg:order-2" data-id="element-770">
              <div className="space-y-3" data-id="element-771">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-772"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-773">
                  Tastings
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-774">
                  Wine Tasting
                </h2>
              </div>
              <div className="space-y-4" data-id="element-775">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-776">
                  Enjoy a sparkling wine tasting experience at Peterson House.
                  Choose five sparkling wines from our wine list for $15.00pp.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-777">
                  Upgrade to our Premium Wine Tasting Experience, $20.00pp, for
                  those who have a drier palate.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-778">
                  Standard Wine Tasting Bookings are for up to eight guests. For
                  bookings of 9-16 guests, see below more information on group
                  bookings.
                </p>
              </div>
              <div className="pt-4" data-id="element-779">
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-780">
                  <Wine size={18} data-id="element-781" />
                  Book Wine Tasting
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-782" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cheese Box Section */}
      <section className="bg-white py-20 px-8" data-id="element-783">
        <div className="max-w-7xl mx-auto" data-id="element-784">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-785">
            {/* Content */}
            <div className="space-y-6 order-1" data-id="element-786">
              <div className="space-y-3" data-id="element-787">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-788"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-789">
                  Add-On
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-790">
                  Why Not Add a Cheese Plate?
                </h2>
              </div>
              <div className="space-y-4" data-id="element-791">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-792">
                  Want to have something a little extra? Add on a delicious
                  cheese plate whilst enjoying your tasting.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-793">
                  At $25.00 per cheese plate, enjoy three cheeses including,
                  camembert, aged vintage cheddar and a smoked cheese, jam,
                  hummus, dried fruit, mixed marinated olives and cornichons,
                  plus water crackers.
                </p>
                <p className="text-gray-500 text-sm leading-relaxed pl-4 border-l-2 border-pink-200" data-id="element-794">
                  Buy online as an extra when you book in your wine tasting
                  experience. Only available with seated wine tastings or
                  premium seated wine tastings.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2" data-id="element-795">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/3-cheeseplate-1.12.25.jpg" alt="Cheese box pairing" className="w-full h-full object-cover" data-id="element-796" />
            </div>
          </div>
        </div>
      </section>

      {/* Group Tastings Section */}
      <section className="bg-neutral-100 py-20 px-8" data-id="element-797">
        <div className="max-w-7xl mx-auto" data-id="element-798">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-799">
            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-1" data-id="element-800">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Glass-1-Right-cellar-door.jpg" alt="Group wine tasting" className="w-full h-full object-cover" data-id="element-801" />
            </div>

            {/* Content */}
            <div className="space-y-6 order-1 lg:order-2" data-id="element-802">
              <div className="space-y-3" data-id="element-803">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-804"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-805">
                  Groups
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-806">
                  Cellar Door Group Tastings
                </h2>
              </div>
              <div className="space-y-4" data-id="element-807">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-808">
                  Planning a girls' trip, hens party, or group day out in the
                  Hunter Valley? Our group wine tastings are perfect for groups
                  of 9–16 guests and are only $30.00pp.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-809">
                  Your experience includes a set tasting of our premium
                  sparkling wines plus a gift pack featuring a Pink Blush
                  piccolo, vanilla lip balm, bling novelty glasses, sparkly pen,
                  magnet, and a delicious cupcake paired with a sweet wine to
                  finish.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-810">
                  The perfect Hunter Valley wine experience—bubbles, treats, and
                  unforgettable fun.
                </p>
              </div>
              <div className="pt-4" data-id="element-811">
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-812">
                  <Users size={18} data-id="element-813" />
                  Book Group Tasting
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-814" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gelato & Wine Tasting Section */}
      <section className="bg-white py-20 px-8" data-id="element-815">
        <div className="max-w-7xl mx-auto" data-id="element-816">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-817">
            {/* Content */}
            <div className="space-y-6 order-1" data-id="element-818">
              <div className="space-y-3" data-id="element-819">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-820"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-821">
                  Unique Experience
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-822">
                  Gelato & Sparkling Wine Tasting
                </h2>
              </div>
              <div className="space-y-4" data-id="element-823">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-824">
                  An experience like no other in the Hunter Valley. Come and
                  enjoy this sensory experience of our delicious sparkling wine
                  and a range of locally sourced unique gelato for $35.00pp.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-825">
                  Taste four sparkling wines, matched with four different
                  flavours of gelato. Fun fact: the flavours are a mystery,
                  keeping you guessing during the experience.
                </p>
                <p className="text-gray-500 text-sm leading-relaxed pl-4 border-l-2 border-pink-200" data-id="element-826">
                  Bookings Essential. Over 18 only. Unfortunately we are not
                  able to cater to dietary requirements.
                </p>
              </div>
              <div className="pt-4" data-id="element-827">
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-828">
                  <IceCream size={18} data-id="element-829" />
                  Book Gelato Experience
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-830" />
                </button>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2" data-id="element-831">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Gelato-tasting-Peterson-House.jpg" alt="Gelato and wine pairing" className="w-full h-full object-cover" data-id="element-832" />
            </div>
          </div>
        </div>
      </section>

      {/* Booking Section */}
      <section id="cellar-door-booking" className="bg-white py-20 px-8" data-id="element-833">
        <div className="max-w-7xl mx-auto" data-id="element-834">
          <iframe src="https://bookings.nowbookit.com/?accountid=72e321b2-4563-4ea2-98b7-ddb19c803f53&venueid=1758&theme=light&colors=hex,263238" className="w-full border-0" style={{
          minHeight: '600px'
        }} data-id="element-835"></iframe>
          <script src="https://plugins.nowbookit.com/iframe-resizer-build/bundle.js" data-id="element-836"></script>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-837" />
    </div>;
}